var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container column" },
    [
      _c(
        "el-card",
        { staticClass: "card", attrs: { id: "os-main" } },
        [
          _c("h4", { staticClass: "card-title" }, [
            _vm._v("Relatórios de Ordens de Serviço")
          ]),
          _c(
            "el-card",
            { staticClass: "card mb" },
            [
              _c("Filtro", {
                attrs: { isFiltroProcesso: false },
                on: { search: _vm.pesquisarOS }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "radio-buttons" },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.isTabelaOS,
                    callback: function($$v) {
                      _vm.isTabelaOS = $$v
                    },
                    expression: "isTabelaOS"
                  }
                },
                [
                  _c("el-radio-button", { attrs: { label: false } }, [
                    _vm._v("Gráfico")
                  ]),
                  _c("el-radio-button", { attrs: { label: true } }, [
                    _vm._v("Tabela")
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm.isTabelaOS
            ? _c(
                "el-card",
                { key: "tabela-os", staticClass: "card" },
                [
                  _c("TabelaOS", { attrs: { dados: _vm.dadosOS } }),
                  _c(
                    "el-row",
                    { staticClass: "page-margin" },
                    [
                      _c("app-paginacao", {
                        attrs: {
                          total: _vm.totalEventosOS,
                          pagina: _vm.filtroOs.pagina + 1,
                          tamanhoPagina: _vm.filtroOs.tamanhoPagina
                        },
                        on: { changePage: _vm.changePageOs }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.isTabelaOS && _vm.dadosOS.length > 0
            ? _c(
                "div",
                {
                  key: "grafico-os",
                  staticClass: "graphs-card",
                  attrs: { id: "graphs-card" }
                },
                [
                  _c("el-row", { staticClass: "descricao" }, [
                    _c("div", { staticClass: "pendentes" }, [
                      _c("div", { staticClass: "cinza" }),
                      _vm._v("Processos pendentes")
                    ]),
                    _c("div", { staticClass: "tramitados" }, [
                      _c("div", { staticClass: "verde" }),
                      _vm._v("Processos tramitados")
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "grafico-container" },
                    _vm._l(_vm.dadosOS, function(os, idx) {
                      return _c(
                        "div",
                        {
                          key: os.idOS,
                          staticClass: "graphs-card-body",
                          class: ["graph_" + (idx + 1)]
                        },
                        [_c("Grafico", { attrs: { dados: os } })],
                        1
                      )
                    }),
                    0
                  ),
                  _c(
                    "el-row",
                    { staticClass: "page-margin" },
                    [
                      _c("app-paginacao", {
                        attrs: {
                          total: _vm.totalEventosOS,
                          pagina: _vm.filtroOs.pagina + 1,
                          tamanhoPagina: _vm.filtroOs.tamanhoPagina
                        },
                        on: { changePage: _vm.changePageOs }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          !_vm.isTabelaOS && _vm.dadosOS.length === 0
            ? _c("div", { key: "empty-data", staticClass: "graphs-card" }, [
                _c("div", { staticClass: "no-data" }, [_vm._v("Sem dados")])
              ])
            : _vm._e(),
          _vm.dadosOS.length > 0
            ? _c(
                "el-row",
                { staticClass: "button-row" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "primary",
                      on: {
                        click: function($event) {
                          return _vm.exportarOS(_vm.isTabelaOS)
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fal fa-file-csv" }),
                      _c("span", [_vm._v("  Exportar CSV")])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "card", attrs: { id: "processo-main" } },
        [
          _c("h4", { staticClass: "card-title" }, [_vm._v("Processos")]),
          _c(
            "el-card",
            { staticClass: "card mb" },
            [
              _c("Filtro", {
                attrs: { isFiltroProcesso: true },
                on: { search: _vm.pesquisarProcesso }
              })
            ],
            1
          ),
          _c(
            "el-card",
            { staticClass: "card" },
            [
              _c("TabelaProcesso", { attrs: { dados: _vm.dadosProcesso } }),
              _c(
                "el-row",
                { staticClass: "page-margin" },
                [
                  _c("app-paginacao", {
                    attrs: {
                      total: _vm.totalEventosTabelaProcesso,
                      pagina: _vm.filtroProcesso.pagina + 1,
                      tamanhoPagina: 15
                    },
                    on: { changePage: _vm.changePageProcesso }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm.dadosProcesso.length > 0
            ? _c(
                "el-row",
                { staticClass: "button-row" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "primary",
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.exportarProcesso()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fal fa-file-csv" }),
                      _c("span", [_vm._v("  Exportar")])
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cb8683f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cb8683f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios/os/OS.vue
// module id = null
// module chunks = 